import React from 'react'
import PropTypes from 'prop-types'
import SemiCircularGauge from './SemiCircularGauge'
import Text from './Text'
import Tooltip from './Tooltip'

const CARD_CLASSES = [
  'tw:w-full tw:flex tw:items-center tw:gap-4 tw:text-left',
  'tw:bg-white tw:border tw:border-solid tw:border-ds-neutral-lowest',
  'tw:rounded-md! tw:px-6 tw:py-4 tw:cursor-pointer',
  'tw:hover:bg-ds-neutral-lowest-enabled tw:transition-colors',
  'tw:focus-visible:outline-2 tw:focus-visible:outline-ds-primary'
].join(' ')

const NAME_CLASSES = 'tw:m-0! tw:text-base tw:font-medium tw:leading-tight '
  + 'tw:text-ds-neutral-highest'

const SCORE_CLASSES = 'tw:m-0! tw:flex tw:items-baseline tw:gap-0.5 '
  + 'tw:text-lg tw:font-semibold tw:leading-tight tw:text-gray-800'

const SUFFIX_CLASSES = 'tw:text-base tw:font-medium tw:text-gray-500'

const SectionGaugeCard = ({
  name, gaugeValue, main, suffix, showEmptyTooltip, emptyTooltip, onClick
}) => (
  <button
    aria-label={`Voir le détail de ${name}`}
    className={CARD_CLASSES}
    type="button"
    onClick={onClick}
  >
    <SemiCircularGauge ariaLabel={`Indicateur de ${name}`} value={gaugeValue} />
    <div className="tw:flex tw:flex-col tw:gap-1 tw:min-w-0 tw:flex-1">
      <div className="tw:flex tw:items-center tw:gap-1 tw:min-w-0">
        <Text
          asElement="p"
          className={NAME_CLASSES}
          wrapperClassName="tw:block tw:min-w-0 tw:flex-1"
          truncate
        >
          {name}
        </Text>
        {showEmptyTooltip ? (
          <Tooltip content={emptyTooltip}>
            <i
              aria-label={emptyTooltip}
              className="fas fa-question-circle tw:text-sm tw:text-ds-neutral-high tw:shrink-0"
            />
          </Tooltip>
        ) : null}
      </div>
      <p className={SCORE_CLASSES}>
        {main}
        {suffix ? <span className={SUFFIX_CLASSES}>{suffix}</span> : null}
      </p>
    </div>
    <i
      aria-hidden="true"
      className="fas fa-chevron-right tw:text-ds-neutral-high tw:text-base tw:shrink-0"
    />
  </button>
)

SectionGaugeCard.propTypes = {
  emptyTooltip: PropTypes.string,
  gaugeValue: PropTypes.number,
  main: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  showEmptyTooltip: PropTypes.bool,
  suffix: PropTypes.string
}

SectionGaugeCard.defaultProps = {
  emptyTooltip: '',
  gaugeValue: null,
  showEmptyTooltip: false,
  suffix: null
}

export default SectionGaugeCard
